import 'flb-ui/dist/flb-ui.css'
import '../src/application.sass'
import 'flb-ui'
import hljs from 'highlight.js'

import Rails from '@rails/ujs'
Rails.start()
hljs.initHighlightingOnLoad()
window.hljs = hljs
